import { HomeView } from '@pages/Home';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/__auth/')({
  component: HomeView,
});
